import { createCommonjsModule } from '../../../../_virtual/_commonjsHelpers.js';

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

export { arrayWithHoles as a };
